export interface SuggestionItem {
  id: string;
  label: string;
  content: string;
  /** Sample text a template preview shows for this item. Absent = show `content`. */
  preview?: string | null;
  type: SuggestionType;
  providerIds?: string[];
  noteTemplateIds?: string[];
  noteQuestionIds?: string[];
}

export type SuggestionType =
  | "SAVED"
  | "PERSONAL"
  | "TENANT"
  | "ASSISTANT"
  | "PATIENT"
  | "MEMBERSHIP"
  // The patient's enrolment in a plan, as against MEMBERSHIP, the plan itself.
  | "MEMBERSHIP_ENROLLMENT"
  | "NOTE_TEMPLATE"
  | "EVENT"
  | "EMAIL"
  // The provider who sent a form, supplying {provider.*} in its text. Comes from the
  // API's own SuggestionType.
  | "PROVIDER"
  // Client-only: @-mentioning a teammate in a task or a team chat. Never sent to the
  // API, which 422s it. Named TEAM rather than PROVIDER so the two cannot collide —
  // form provider fields would otherwise render under the "Team Members" header.
  | "TEAM";

/** What a template preview shows in place of this suggestion. */
export function suggestionPreview(item: SuggestionItem): string {
  return item.preview || item.content;
}

/**
 * What a picker row shows under the label: the text that will actually be
 * inserted when the surface inserts text, the preview when it inserts a pill.
 */
export function suggestionPickerText(
  item: SuggestionItem,
  { insertsText }: { insertsText: boolean },
): string {
  return insertsText ? item.content : suggestionPreview(item);
}
